import { makeStyles } from 'tss-react/mui';
import { Typography } from '@mui/material';

import { Button, UpliftThemeProvider } from '@uplift/ui-v2';

export type ShowMoreProps = {
  onLoadMore: () => void;
};

export const ShowMore: React.FC<ShowMoreProps> = props => {
  const { classes } = useShowMoreStyles();

  return (
    <UpliftThemeProvider>
      <div className={classes.root}>
        <Typography color="textSecondary">
          Not finding what you're looking for?
        </Typography>
        <Button
          color="secondary"
          variant="outlined"
          onClick={props.onLoadMore}
        >
          Load more matches
        </Button>
      </div>
    </UpliftThemeProvider>
  );
};

const useShowMoreStyles = makeStyles({ name: 'ShowMore' })(theme => ({
  root: {
    margin: theme.spacing(5, 'auto', 0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}));
